import { render, staticRenderFns } from "./ReleaseLabel.vue?vue&type=template&id=79b41f12&"
import script from "./ReleaseLabel.vue?vue&type=script&lang=js&"
export * from "./ReleaseLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports